import {signal} from "@preact/signals-react";

export const keywordsTableData = signal([])
export const reloadKeywordsTableData = signal(false)

export const keywordFilters = signal({})

export const isEmpty = signal(false)

export const resetManagementKeywordsCrudSignals = () => {
    keywordsTableData.value = []
    reloadKeywordsTableData.value = false
    keywordFilters.value = {}
    isEmpty.value = false
}
